import { usePostApiV1ExamAnswerAnsweridAiCorrection } from '@/shared/api/generated';

/**
 * Hook para solicitar a correção automática de uma resposta dissertativa por IA.
 *
 * Suportado apenas para questões do tipo SingleLineText e MultilineText.
 * Retorna sugestão de nota e feedback detalhado sem salvar no banco.
 *
 * @returns Mutation do TanStack Query para o endpoint de correção por IA
 *
 * @example
 * ```tsx
 * const { mutate: requestAiCorrection, isPending } = useAiCorrection();
 * requestAiCorrection(
 *   { answerId: 123 },
 *   { onSuccess: (data) => console.log(data.suggestedGrade) },
 * );
 * ```
 */
export function useAiCorrection() {
  return usePostApiV1ExamAnswerAnsweridAiCorrection();
}
